import type { LucideIcon } from "lucide-react";
import { pageActionGroupClassName } from "@/lib/page-action-button";
import { cn } from "@/lib/utils";
import { PageMobileActions } from "@/components/common/PageMobileActions";
import type { SpeedDialAction } from "@/components/common/MobileSpeedDial";

interface RagPageHeaderProps {
  icon: LucideIcon;
  title: React.ReactNode;
  subtitle?: string;
  action?: React.ReactNode;
  mobileActions?: SpeedDialAction[];
  className?: string;
}

export function RagPageHeader({
  icon: Icon,
  title,
  subtitle,
  action,
  mobileActions,
  className,
}: RagPageHeaderProps) {
  const hasMobileActions = Boolean(mobileActions?.length);

  return (
    <>
      <div className={cn("mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between", className)}>
        <div className="flex min-w-0 flex-1 items-start gap-3.5">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl border border-[var(--primary-soft-border)] bg-[var(--primary-soft-bg)] sm:h-11 sm:w-11 dark:border-violet-400/30 dark:bg-violet-500/15">
            <Icon className="h-4 w-4 text-[#7c3aed] sm:h-[22px] sm:w-[22px] dark:text-violet-300" strokeWidth={1.75} />
          </div>
          <div className="min-w-0">
            <h1 className="truncate text-[22px] font-semibold text-[var(--lm-foreground-strong)] dark:text-white">{title}</h1>
            {subtitle ? (
              <p className="mt-1 hidden text-[13px] text-[var(--lm-muted)] sm:block dark:text-slate-400">{subtitle}</p>
            ) : null}
          </div>
        </div>
        {action ? (
          <div className={cn(pageActionGroupClassName, "w-full sm:w-auto", hasMobileActions && "hidden sm:flex")}>
            {action}
          </div>
        ) : null}
      </div>
      {hasMobileActions ? <PageMobileActions actions={mobileActions!} /> : null}
    </>
  );
}
